export default "__VITE_ASSET__Dq2x6NGg__"